import { orderDocSerializer, orderStatuses } from "@megaron/crm-contracts";
import { HttpAction } from "@megaron/http-service";
import { orderSortFields } from "@megaron/megarax-uri";
import { Serializers } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

export { orderSortFields };
export type { OrderSortField } from "@megaron/megarax-uri";

export const orderActions = {
  searchOrders: HttpAction({
    path: "/orders",
    qsSerializer: Serializers.object({
      sellToId: uuidSerializer.array().asJsonString(),
      searchText: Serializers.string,
      sort: Serializers.sortFilter(orderSortFields).asJsonString(),
      status: Serializers.stringOneOf(...orderStatuses)
        .array()
        .asJsonString(),
      type: Serializers.stringOneOf("order", "creditMemo").array().asJsonString(),
      region: Serializers.string.array().asJsonString(),
      month: Serializers.month.array().asJsonString(),
      limit: Serializers.integer,
      offset: Serializers.integer,
    }).partial(),
    valueSerializer: Serializers.paginatedList(orderDocSerializer),
    requiresAuth: true,
  }),
};
